import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import EmailTemplateForm from './EmailTemplateForm';
import EmailTemplateFormService from '../services/EmailTemplateFormService';

class EmailTemplateFormContainer extends React.Component {
  static propTypes = {
    emailTemplateId: PropTypes.string,
  };

  static defaultProps = {
    emailTemplateId: null,
  };

  componentDidMount() {
    EmailTemplateFormService.handleLoad(this.props.emailTemplateId);
  }

  render() {
    return (
      <EmailTemplateForm
        onChange={EmailTemplateFormService.form.setValue}
        onSubmit={EmailTemplateFormService.handleSubmit}
        onReset={EmailTemplateFormService.form.reset}
        onEdit={EmailTemplateFormService.handleEdit}
        onDelete={EmailTemplateFormService.handleDelete}
        onTemplateDownload={EmailTemplateFormService.handleTemplateDownload}
        values={EmailTemplateFormService.form.getValues()}
        errors={EmailTemplateFormService.form.errors}
        loading={EmailTemplateFormService.fetch.fetching}
        submitting={EmailTemplateFormService.submit.fetching}
      />
    );
  }
}

export default observer(EmailTemplateFormContainer);
